import React from "react";
import Container from "./NotFound.styles";

function NotFound() {
  return <Container>Not Found</Container>;
}

export default NotFound;
